"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _ModalView = _interopRequireDefault(require("./ModalView"));

var _ModalStyles = _interopRequireDefault(require("./ModalStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

///require("../../assets/css/logo-alt.png")
var _default = function _default(_ref) {
  var _ReactDOMServer$rende;

  var logoUrl = _ref.logoUrl,
      preTitle = _ref.preTitle,
      title = _ref.title,
      subTitle = _ref.subTitle,
      body = _ref.body,
      onClose = _ref.onClose,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === void 0 ? false : _ref$submitting,
      fullScreen = _ref.fullScreen,
      _ref$opened = _ref.opened,
      opened = _ref$opened === void 0 ? false : _ref$opened,
      _ref$saveButton = _ref.saveButton,
      saveButton = _ref$saveButton === void 0 ? {
    text: "Save",
    onClick: console.log,
    ButtonProps: {}
  } : _ref$saveButton,
      _ref$secondaryButton = _ref.secondaryButton,
      secondaryButton = _ref$secondaryButton === void 0 ? null : _ref$secondaryButton;
  var classes = (0, _ModalStyles["default"])();
  !!opened && (typeof title === 'string' ? _reactGa["default"].modalview("/".concat((title !== null && title !== void 0 ? title : "").toString().toLowerCase().replace(/[^\-A-Za-z0-9]/g, '-'))) : _reactGa["default"].modalview("/".concat(((_ReactDOMServer$rende = _server["default"].renderToString(title)) !== null && _ReactDOMServer$rende !== void 0 ? _ReactDOMServer$rende : "").toString().toLowerCase().replace(/<[^>]+>/g, '').replace(/[^\-A-Za-z0-9]/g, '-'))));
  return /*#__PURE__*/_react["default"].createElement(_ModalView["default"], {
    classes: classes,
    logoUrl: logoUrl,
    preTitle: preTitle,
    title: title,
    subTitle: subTitle,
    body: body,
    onClose: onClose,
    submitting: submitting,
    fullScreen: fullScreen,
    opened: opened,
    saveButton: saveButton,
    secondaryButton: secondaryButton
  });
};

exports["default"] = _default;